import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import TopNavigation from '../TopNavigation'
import { Container, Row, Col, Button } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import withAppconfig from '../AppContext'
import LottieAnim from './LottieAnim'
import { setAddCardReturn, takeAddCardReturn } from '../utils/storedcards'

function AddCardResult({ appconfig }) {
  const params = useParams()
  const history = useHistory()
  const { t } = useTranslation()
  const isSuccess = params.status === 'success'
  // the card was saved, but the continuous membership it was added for still has the old one
  const subscriptionError = params.status === 'subscriptionerror'
  // Set by the screen that sent the customer here (e.g. a continuous membership checkout); read once.
  const [returnPath] = React.useState(() => takeAddCardReturn())

  const onComplete = () => {
    history.push(returnPath || appconfig.pathPrefix + '/profile')
  }

  return (
    <div className='full-page-background'>
      <TopNavigation title={t('add_card')} />
      <Container className='front'>
        <Row className='text-center' style={{ paddingTop: 20, marginBottom: 30 }}>
          <Col className={'mx-auto'} xs={3}>
            <LottieAnim status={params.status} onComplete={isSuccess ? onComplete : undefined} />
            {isSuccess ? t('card_added') : subscriptionError ? t('card_added_subscription_error') : t('card_add_failed')}
          </Col>
        </Row>
        {subscriptionError ? (
          <Row className='text-center'>
            <Col>
              <Button size='sm' color='primary' onClick={() => history.push(appconfig.pathPrefix + '/profile')}>
                {t('back')}
              </Button>
            </Col>
          </Row>
        ) : !isSuccess ? (
          <Row className='text-center'>
            <Col>
              <Button
                size='sm'
                color='primary'
                onClick={() => {
                  // keep where to come back to for the next attempt
                  setAddCardReturn(returnPath)
                  history.push(appconfig.pathPrefix + '/addcard')
                }}
              >
                {t('retry')}
              </Button>{' '}
              <Button size='sm' color='link' onClick={() => history.push(returnPath || appconfig.pathPrefix + '/profile')}>
                {t('back')}
              </Button>
            </Col>
          </Row>
        ) : null}
      </Container>
    </div>
  )
}

export default withAppconfig(AddCardResult)
